export default function Tag({theme = 'primary', className = '', children, ...rest}) {
    const themeClasses = theme === 'primary' ? 'tag-primary' : 'tag-secondary';

    return (
        <div
            className={`tag inline-flex font-bold text-sm leading-none py-3 px-7 rounded-full ${themeClasses} ${className}`} {...rest}>
            {children}
        </div>
    )
}
